// extracted by mini-css-extract-plugin
export default {"catalog":"CatalogContent_catalog__noB86","catalog__title":"CatalogContent_catalog__title__yCz24"};